export const APP_ROLE = Object.freeze({
  ADMIN: "Admin",
  OTHER: "Other",
});
